import * as React from 'react'
import { FAQModuleKindProps, FAQModuleProps } from './types'
import { ModuleLayout } from '../../components/ModuleLayout'
import './index.scss'
import { TabButton } from '../../components/TabButton'
import { Accordion } from '../../components/Accordion'
import { SegmentContext } from '../../hooks/SegmentContext'

export const FAQModule: React.FC<FAQModuleProps> = ({ moduleTitle, kinds }) => {
  const { segmentTrack } = React.useContext(SegmentContext)
  const safeKinds = kinds.filter((kind) => kind.items && kind.items.length > 0)

  const [activeKind, setActiveKind] = React.useState<FAQModuleKindProps>(safeKinds[0])

  function handleKindClick(kind: FAQModuleKindProps) {
    segmentTrack('Help Option Clicked', { widget: true, alt_text: 'ajuda-alt', help_section: 'Dúvidas frequentes', help_subsection: kind.title })
    setActiveKind(kind)
  }

  return (
    <ModuleLayout>
      <div className="faq-container">
        <div className="module-content">
          <h1 className="module-title">{moduleTitle}</h1>
          <div className="kinds-container">
            {safeKinds.map((kind) => {
              return <TabButton key={kind.id} test-id={kind.id} title={kind.title} isActive={activeKind.id === kind.id} onClick={() => handleKindClick(kind)} />
            })}
          </div>
          <div className="accordions-container">
            {activeKind.items.map((item) => {
              return <Accordion key={item.title} title={item.title} description={item.description} kindTitle={activeKind.title} />
            })}
          </div>
        </div>
      </div>
    </ModuleLayout>
  )
}
